import axios from "axios";
import FormData from "form-data";

const API_URL = "https://atmos.urbansciences.in/adpl/";

var data = new FormData();

const register = (username, email, password) => {
  return axios.post(API_URL + "register", {
    username,
    email,
    password,
  });
};

function login(username, password) {
  data.append("username", username);
  data.append("password", password);
  var requestOptions = {
    method: "POST",
    body: data,
    redirect: "follow",
  };
  return fetch(API_URL + "login", requestOptions)
    .then((response) => response.json())
    .then((response) => {
      if (response.token) {
        localStorage.setItem("user", response.token);
        localStorage.setItem("status_code", response.status_code);
        localStorage.setItem("logo", response.logo);
        localStorage.setItem("email", response.email);
        localStorage.setItem("check_aqi", response.check_aqi);
        localStorage.setItem("check_calibration", response.check_calibration);
        localStorage.setItem("username", response.username);
      }
      return response;
    });
}

function resetpassword(username) {
  data.append("username", username);
  var requestOptions = {
    method: "POST",
    body: data,
    redirect: "follow",
  };
  return fetch(API_URL + "password_reset", requestOptions)
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
}

function resetpasswordverify(password) {
  data.append("password", password);
  var requestOptions = {
    method: "POST",
    body: data,
    redirect: "follow",
  };
  return fetch(API_URL + "password_reset_verified", requestOptions)
    .then((response) => response.json())
    .then((response) => {
      console.log("response", response);
      return response;
    });
}

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("status_code");
  localStorage.removeItem("logo");
  localStorage.removeItem("email");
  localStorage.removeItem("check_aqi");
  localStorage.removeItem("check_calibration");
  localStorage.removeItem("username");
};

const getCurrentUser = () => {
  return localStorage.getItem("user");
};

export default {
  register,
  login,
  logout,
  getCurrentUser,
  resetpassword,
  resetpasswordverify,
};
